module.exports = __webpack_public_path__ + "img/banner6.32a0608a.jpg";